import React, { Component } from "react";
import Calendar from "react-calendar";
import "react-datepicker/dist/react-datepicker.css";
import "react-infinite-calendar/styles.css";
import { Link } from "react-router";
import Select from "react-select";
import AdmissionApi, { acz } from "../../Services/AdmissionApi";
import "./style.css";
import { toast } from "react-toastify";

class RegistraionForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      id: null,
      school_code: "",
      school_name:"",
      first_name: "",
      last_name: "",
      user_name: "",
      email: "",
      gender: "male",
      date_of_birth: "",
      phone: "",
      password: "",
      father_name: "",
      subjects: [],
      confirm_password: "",
      type: 3,
      options: [],
      show: false,
      errors: {},
      check: false,
    };

    // Bind all handlers (no class fields)
    this.handleRegisterClick = this.handleRegisterClick.bind(this);
    this.handleGenderChange = this.handleGenderChange.bind(this);
    this.showDatePicker = this.showDatePicker.bind(this);
    this.onCalendarChange = this.onCalendarChange.bind(this);
    this.handleOptionChange = this.handleOptionChange.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleDateChange = this.handleDateChange.bind(this);
    this.showSelectedId = this.showSelectedId.bind(this);

    this.updateOtpState = this.updateOtpState.bind(this);
    this.updateState = this.updateState.bind(this);
    this.errorsHandling = this.errorsHandling.bind(this);
    this.handleSubjectCallback = this.handleSubjectCallback.bind(this);
    this.validateSchoolCode = this.validateSchoolCode.bind(this);

    this.admissionsService = new AdmissionApi();
  }

  // ---------- UI helpers ----------
  handleOptionChange(subjects) {
    if (subjects && subjects.length <= 6) {
      const newErrors = Object.assign({}, this.state.errors, { subjects: "" });
      this.setState({ subjects: subjects, errors: newErrors });
    } else {
      const newErrors = Object.assign({}, this.state.errors, {
        subjects: "You have selected maximum subjects",
      });
      this.setState({ errors: newErrors });
    }
  }

  handleChange(evt) {
    if (this.state.check) {
      this.handleValidation();
    }
    var name = evt.target.name;
    var value = evt.target.value;

    // Clear school_code error as user edits
    if (name === "school_code" && this.state.errors && this.state.errors.school_code) {
      const newErrors = Object.assign({}, this.state.errors, { school_code: "" });
      this.setState({ [name]: value, errors: newErrors });
    } else {
      this.setState({ [name]: value });
    }
  }

  showDatePicker() {
    this.setState({ show: !this.state.show });
  }

  handleDateChange(m) {
    var date = this.formatSubmitDate(m);
    var self = this;
    setTimeout(function () {
      self.setState({ date_of_birth: date });
    }, 50);
  }

  onCalendarChange(date) {
    var befor = new Date(date);
    var now = new Date();
    var errors = {};
    if (befor < now) {
      errors["date_of_birth"] = "";
      this.setState({
        date_of_birth: this.formatSubmitDate(date),
        show: !this.state.show,
        errors: errors,
      });
    } else {
      errors["date_of_birth"] = "Date of birth cannot be a future date.";
      this.setState({ errors: errors });
    }
  }

  showSelectedId(event) {
    this.props.changeForm(event);
  }

  // ---------- Formatting ----------
  formatDate(date) {
    var d = new Date(date),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    return [day, month, year].join("-");
  }

  formatSubmitDate(date) {
    var d = new Date(date),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    return [year, month, day].join("-");
  }

  // ---------- School code validation ----------
  // Returns Promise<boolean>
  validateSchoolCode(code) {
    var self = this;
    return new Promise(function (resolve) {
      var q = (code || "").trim();
      if (!q) return resolve(false);

      var url = "v1/school-codes?school_code=" + encodeURIComponent(q);

      self.admissionsService.GetStudentsData(
        function (response) {
          try {
            var d = response && response.data ? response.data : {};
            var embedded = d._embedded || {};
            var list =
              embedded["school-codes"] ||
              embedded.school_codes ||
              embedded.schools ||
              [];
            resolve(Array.isArray(list) && list.length > 0);
          } catch (e) {
            resolve(false);
          }
        },
        url,
        {
          client_id: acz.clientId,
          app_key: acz.appId,
        }
      );
    });
  }

  // ---------- API callbacks ----------
  updateOtpState(_newResponse) {
    // optional mail otp callback
  }

  updateState(newResponse) {
    if (newResponse.data && newResponse.data.success) {
      // SMS OTP
      var smsData = {
        dest_mobileno: newResponse.data.attributes.phone,
        message:
          "Use " +
          newResponse.data.attributes.otp +
          " as one-time password (OTP) for creating an account on NOTIFYi. Valid for 15 minutes. This can be used only once\n\nThanks\nTeam Notifyi",
      };
      this.admissionsService.sendSms(function () {}, smsData);

      // Mail OTP
      var mailobj = {
        action: "send_otp",
        appid: newResponse.data.attributes.appId,
        clientid: newResponse.data.attributes.clientId,
        mail_data: {
          otp: newResponse.data.attributes.otp,
          user_name: this.state.first_name + " " + this.state.last_name,
        },
        address: {
          to: this.state.email,
          name: this.state.first_name + " " + this.state.last_name,
        },
      };
      this.admissionsService.sendMail(this.updateOtpState, mailobj, "settings/v1/mail/send");

      // Local cache
      var categoryObj = {
        first_name: this.state.first_name,
        last_name: this.state.last_name,
        school_code: this.state.school_code,
        gender: this.state.gender,
        date_of_birth: this.formatSubmitDate(this.state.date_of_birth),
        email: this.state.email,
      };
      try {
        localStorage.setItem("userInfo", JSON.stringify(categoryObj));
        localStorage.setItem("userId", newResponse.data.attributes.id);
      } catch (e) {}

      var obj = {
        user_id: newResponse.data.attributes.id,
        school_code: this.state.school_code,
        school_name:this.state.school_name,
        approval_status: 'approved',
        first_name: this.state.first_name,
        last_name: this.state.last_name,
        email: this.state.email,
        password: this.state.password,
        type: newResponse.data.attributes.type,
        otp: newResponse.data.attributes.otp,
        destination_mobile_no: newResponse.data.attributes.phone,
        category: true,
        gender: this.state.gender,
        date_of_birth: this.formatSubmitDate(this.state.date_of_birth),
        phone_number: this.state.phone,
        subjects: this.state.subjects,
        father_name: this.state.father_name,
        active: 1,
      };

      // proceed to OTP screen
      this.props.sendData(obj, "otp-link");
    } else {
      if (newResponse.data && newResponse.data.isInactive) {
        this.props.sendDataWithOtp(
          { email: this.state.email, school_code: this.state.school_code, approval_status:"approved", isInactive: newResponse.data.isInactive },
          "otp-link"
        );
      } else if (newResponse.data && newResponse.data.messages && newResponse.data.messages.body) {
        this.errorsHandling(newResponse.data.messages.body);
      } else {
        // generic error bucket
        this.setState({ errors: Object.assign({}, this.state.errors, { responseError: "Registration failed" }) });
      }
    }
  }

  errorsHandling(data) {
    var errors = {};
    Object.keys(data || {}).forEach(function (key) {
      errors[key] = data[key][0];
    });
    this.setState({ errors: errors });
  }

  // ---------- Validation ----------
  handleGenderChange(e) {
    this.setState({ gender: e.currentTarget.value });
  }

  handleValidation() {
    var fields = this.state;
    var errors = {};
    var formIsValid = true;

    // Email
    if (!fields["email"]) {
      formIsValid = false;
      errors["email"] = "Cannot be empty";
    }
    if (
      fields["email"] &&
      !fields["email"].match(
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      )
    ) {
      formIsValid = false;
      errors["email"] = "Email is not valid";
    }

    // First name
    if (!fields["first_name"]) {
      formIsValid = false;
      errors["first_name"] = "Cannot be empty";
    } else if (!/^[a-zA-Z]+$/.test(fields["first_name"])) {
      formIsValid = false;
      errors["first_name"] = "Only letters";
    }

    // Last name
    if (!fields["last_name"]) {
      formIsValid = false;
      errors["last_name"] = "Cannot be empty";
    } else if (!/^[a-zA-Z]+$/.test(fields["last_name"])) {
      formIsValid = false;
      errors["last_name"] = "Only letters";
    }

    // School code
    if (!fields["school_code"]) {
      formIsValid = false;
      errors["school_code"] = "Cannot be empty";
    }

    // Phone
    if (!fields["phone"]) {
      formIsValid = false;
      errors["phone"] = "Cannot be empty";
    } else if (/^[a-zA-Z]+$/.test(fields["phone"])) {
      formIsValid = false;
      errors["phone"] = "Only numbers";
    }

    // Password
    if (!fields["password"]) {
      formIsValid = false;
      errors["password"] = "Cannot be empty";
    }

    // DOB
    if (!fields["date_of_birth"]) {
      formIsValid = false;
      errors["date_of_birth"] = "Cannot be empty";
    }

    // Subjects
    if (!fields["subjects"] || !Array.isArray(fields["subjects"]) || fields["subjects"].length === 0) {
      formIsValid = false;
      errors["subjects"] = "Cannot be empty";
    }

    // Confirm password
    if (!fields["confirm_password"]) {
      formIsValid = false;
      errors["confirm_password"] = "Cannot be empty";
    } else if (fields["confirm_password"] !== fields["password"]) {
      formIsValid = false;
      errors["confirm_password"] = "Password did not matched";
    }

    errors["responseError"] = "";
    this.setState({ errors: errors });
    return formIsValid;
  }

  // ---------- Signup handler (no async/await) ----------
  handleRegisterClick(e) {
    e.preventDefault();
    this.setState({ check: true });

    if (!this.handleValidation()) return;

    if (!Array.isArray(this.state.subjects) || this.state.subjects.length === 0) {
      var errA = Object.assign({}, this.state.errors, {
        subjects: "You have to select atleast 1 subject and max 6 subjects.",
      });
      this.setState({ errors: errA });
      return;
    }

    var self = this;
    this.validateSchoolCode(this.state.school_code).then(function (isValid) {
      if (!isValid) {
        toast.error("Invalid school code.");
        // var errB = Object.assign({}, self.state.errors, { school_code: "Invalid school code" });
        self.setState({ errors: errB });
        return;
      }

      // proceed with existing signup flow
      var obj = {
        school_code: self.state.school_code,
        first_name: self.state.first_name,
        last_name: self.state.last_name,
        email: self.state.email,
        gender: self.state.gender,
        date_of_birth: self.formatSubmitDate(self.state.date_of_birth),
        phone: self.state.phone,
        password: self.state.password,
        subjects: self.state.subjects,
        father_name: self.state.father_name,
        type: self.state.type,
      };
      self.admissionsService.createNew(self.updateState, obj, "v1/users/register");
    });
  }

  // ---------- Load subjects on mount ----------
  handleSubjectCallback(newResponse) {
    if (newResponse.data && newResponse.data.success) {
      var list = (newResponse.data._embedded && newResponse.data._embedded.schoolsubject) || [];
      var indents = [];
      for (var i = 0; i < list.length; i++) {
        indents.push({ label: list[i].name, value: list[i].id });
      }
      this.setState({ options: indents });
    }
  }

  componentDidMount() {
    this.admissionsService.GetData(this.handleSubjectCallback, "v1/students/school/subject");
  }

  // ---------- Render ----------
  render() {
    var subjects = this.state.subjects;
    var options = this.state.options;

    return (
      <React.Fragment>
        <h1>Signup</h1>
        <div className="row g-bg-white rounded">
          <div className={this.state.errors["first_name"] ? "col-sm-12 col-md-6" : "g-mb-10 col-sm-12 col-md-6"}>
            <div className="input-group admn-input-group">
              <span className="input-group-addon g-width-50 g-brd-secondary-light-v2 g-bg-secondary g-rounded-right-0">
                <i className="fa fa-user"></i>
              </span>
              <input
                className="form-control g-brd-secondary-light-v2 g-bg-secondary g-bg-secondary-dark-v1--focus g-rounded-left-0 g-px-20 g-py-12"
                type="text"
                placeholder="First Name*"
                name="first_name"
                onChange={this.handleChange}
              />
            </div>
            <span style={{ color: "red" }}>{this.state.errors["first_name"]}</span>
          </div>

          <div className={this.state.errors["last_name"] ? "col-sm-12 col-md-6" : "g-mb-10 col-sm-12 col-md-6"}>
            <div className="input-group admn-input-group">
              <span className="input-group-addon g-width-50 g-brd-secondary-light-v2 g-bg-secondary g-rounded-right-0">
                <i className="fa fa-user"></i>
              </span>
              <input
                className="form-control g-brd-secondary-light-v2 g-bg-secondary g-bg-secondary-dark-v1--focus g-rounded-left-0 g-px-20 g-py-12"
                type="text"
                placeholder="Last Name*"
                name="last_name"
                onChange={this.handleChange}
              />
            </div>
            <span style={{ color: "red" }}>{this.state.errors["last_name"]}</span>
          </div>

          <div className={this.state.errors["school_code"] ? "col-sm-12" : "g-mb-10 col-sm-12"}>
            <div className="input-group admn-input-group">
              <span className="input-group-addon g-width-50 g-brd-secondary-light-v2 g-bg-secondary g-rounded-right-0">
                <i className="fa fa-university"></i>
              </span>
              <input
                className="form-control g-brd-secondary-light-v2 g-bg-secondary g-bg-secondary-dark-v1--focus g-rounded-left-0 g-px-20 g-py-12"
                type="text"
                placeholder="School Code*"
                name="school_code"
                value={this.state.school_code}
                onChange={this.handleChange}
              />
            </div>
            <span style={{ color: "red" }}>{this.state.errors["school_code"]}</span>
          </div>

          <div className={this.state.errors["gender"] ? "col-sm-12" : "g-mb-10 col-sm-12"}>
            <div className="input-group admn-input-group">
              <span className="input-group-addon g-width-50 g-brd-secondary-light-v2 g-bg-secondary g-rounded-right-0">
                <i className="fa fa-transgender"></i>
              </span>
              <div className="btn-group justified-content">
                <label className="u-check">
                  <input
                    className="g-hidden-xs-up g-pos-abs g-top-0 g-left-0"
                    name="male"
                    type="radio"
                    checked={this.state.gender === "male"}
                    value="male"
                    onChange={this.handleGenderChange}
                  />
                  <span className="btn btn-md btn-block u-btn-outline-lightgray g-color-white--checked g-bg-primary--checked rounded-0">
                    Male
                  </span>
                </label>
                <label className="u-check">
                  <input
                    className="g-hidden-xs-up g-pos-abs g-top-0 g-left-0"
                    name="female"
                    type="radio"
                    checked={this.state.gender === "female"}
                    value="female"
                    onChange={this.handleGenderChange}
                  />
                  <span className="btn btn-md btn-block u-btn-outline-lightgray g-color-white--checked g-bg-primary--checked g-brd-left-none--md rounded-0">
                    Female
                  </span>
                </label>
              </div>
            </div>
            <span style={{ color: "red" }}>{this.state.errors["gender"]}</span>
          </div>

          <div className={this.state.errors["subjects"] ? "col-sm-12" : "g-mb-10 col-sm-12"}>
            <div className="input-group" style={{ boxShadow: "0 2px 4px 0 rgb(48 49 51 / 10%), 0 0 1px 0 rgb(48 49 51 / 5%)" }}>
              <div className="input-group-prepend input-icon-react-select">
                <span className="input-group-text">
                  <i className="fa fa-book"></i>
                </span>
              </div>
              <Select
                styles={{ control: function (base) { return Object.assign({}, base, { background: "#fff", boxShadow: "none", border: "none" }); } }}
                isMulti
                value={subjects}
                onChange={this.handleOptionChange}
                options={options}
                placeholder="Select your subjects*"
              />
            </div>
            <span style={{ color: "red" }}>{this.state.errors["subjects"]}</span>
          </div>

          <div className={this.state.errors["father_name"] ? "col-sm-12 col-md-6" : "g-mb-10 col-sm-12 col-md-6"}>
            <div className="input-group admn-input-group">
              <span className="input-group-addon g-width-50 g-brd-secondary-light-v2 g-bg-secondary g-rounded-right-0">
                <i className="fa fa-user"></i>
              </span>
              <input
                className="form-control g-brd-secondary-light-v2 g-bg-secondary g-bg-secondary-dark-v1--focus g-rounded-left-0 g-px-20 g-py-12"
                type="text"
                placeholder="Father's Name"
                name="father_name"
                onChange={this.handleChange}
              />
            </div>
            <span style={{ color: "red" }}>{this.state.errors["father_name"]}</span>
          </div>

          <div className={this.state.errors["date_of_birth"] ? "col-sm-12 col-md-6" : "g-mb-10 col-sm-12 col-md-6"}>
            <div className="input-group admn-input-group">
              <span className="input-group-addon g-width-50 g-brd-secondary-light-v2 g-bg-secondary g-rounded-right-0">
                <i className="fa fa-calendar"></i>
              </span>
              <input
                className="form-control g-brd-secondary-light-v2 g-bg-secondary g-bg-secondary-dark-v1--focus g-rounded-left-0 g-px-20 g-py-12"
                type="tel"
                placeholder="Date of Birth*"
                readOnly
                value={this.state.date_of_birth}
                name="date_of_birth"
                onClick={this.showDatePicker}
              />
            </div>
            <span style={{ color: "red" }}>{this.state.errors["date_of_birth"]}</span>
            {this.state.show ? <Calendar onChange={this.onCalendarChange} value={this.state.date} /> : ""}
          </div>

          <div className={this.state.errors["email"] ? "col-sm-12 col-md-6" : "g-mb-10 col-sm-12 col-md-6"}>
            <div className="input-group admn-input-group">
              <span className="input-group-addon g-width-50 g-brd-secondary-light-v2 g-bg-secondary g-rounded-right-0">
                <i className="fa fa-envelope"></i>
              </span>
              <input
                className="form-control g-brd-secondary-light-v2 g-bg-secondary g-bg-secondary-dark-v1--focus g-rounded-left-0 g-px-20 g-py-12"
                type="email"
                placeholder="E-mail address*"
                name="email"
                onChange={this.handleChange}
              />
            </div>
            <span style={{ color: "red" }}>{this.state.errors["email"]}</span>
          </div>

          <div className={this.state.errors["phone"] ? "col-sm-12 col-md-6" : "g-mb-10 col-sm-12 col-md-6"}>
            <div className="input-group admn-input-group">
              <span className="input-group-addon g-width-50 g-brd-secondary-light-v2 g-bg-secondary g-rounded-right-0">
                <i className="fa fa-phone"></i>
              </span>
              <input
                className="form-control g-brd-secondary-light-v2 g-bg-secondary g-bg-secondary-dark-v1--focus g-rounded-left-0 g-px-20 g-py-12"
                type="tel"
                placeholder="Phone Number*"
                maxLength="10"
                name="phone"
                onChange={this.handleChange}
              />
            </div>
            <span style={{ color: "red" }}>{this.state.errors["phone"]}</span>
          </div>

          <div className={this.state.errors["password"] ? "col-sm-12 col-md-6" : "g-mb-10 col-sm-12 col-md-6"}>
            <div className="input-group admn-input-group">
              <span className="input-group-addon g-width-50 g-brd-secondary-light-v2 g-bg-secondary g-rounded-right-0">
                <i className="fa fa-lock"></i>
              </span>
              <input
                className="form-control g-brd-secondary-light-v2 g-bg-secondary g-bg-secondary-dark-v1--focus g-rounded-left-0 g-px-20 g-py-12"
                type="password"
                placeholder="Password*"
                name="password"
                onChange={this.handleChange}
              />
            </div>
            <span style={{ color: "red" }}>{this.state.errors["password"]}</span>
          </div>

          <div className={this.state.errors["confirm_password"] ? "col-sm-12 col-md-6" : "g-mb-10 col-sm-12 col-md-6"}>
            <div className="input-group admn-input-group">
              <span className="input-group-addon g-width-50 g-brd-secondary-light-v2 g-bg-secondary g-rounded-right-0">
                <i className="fa fa-lock"></i>
              </span>
              <input
                className="form-control g-brd-secondary-light-v2 g-bg-secondary g-bg-secondary-dark-v1--focus g-rounded-left-0 g-px-20 g-py-12"
                type="password"
                placeholder="Confirm Password*"
                name="confirm_password"
                onChange={this.handleChange}
              />
            </div>
            <span style={{ color: "red" }}>{this.state.errors["confirm_password"]}</span>
          </div>

          <div className="col-sm-12">
            By signing up you agree to the Admizzionz Campuz{" "}
            <Link to="/privacyPolicy" className="auth-link">
              Policies and guidelines
            </Link>
            .
          </div>

          <div className="d-flex col-md-12 my-1">
            <button
              type="submit"
              id="otp-link"
              className="admn-btn w-100 btn u-shadow-v33 g-color-white g-bg-primary g-bg-main--hover g-font-size-default rounded g-px-25 g-py-7 ml-auto"
              onClick={this.handleRegisterClick}
            >
              Signup
            </button>
          </div>

          <div className="col-sm-12 text-center">
            Already have an account?{" "}
            <button
              type="button"
              className="btn btn-link p-0 auth-link"
              id="signin-link"
              onClick={this.showSelectedId}
            >
              Login
            </button>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default RegistraionForm;



/** WEBPACK FOOTER **
 ** ./src/components/SignIn/RegistraionForm.js
 **/